import { Language } from '../types'
import { getAllergenById } from '../data/allergens'

export const LANGUAGES = {
  de: { name: 'Deutsch', flag: '🇩🇪' },
  en: { name: 'English', flag: '🇬🇧' },
  fr: { name: 'Français', flag: '🇫🇷' },
  es: { name: 'Español', flag: '🇪🇸' },
  it: { name: 'Italiano', flag: '🇮🇹' },
  ar: { name: 'العربية', flag: '🇸🇦' },
}

const LABEL_TRANSLATIONS = {
  ingredients: {
    de: 'Zutaten',
    en: 'Ingredients',
    fr: 'Ingrédients',
    es: 'Ingredientes',
    it: 'Ingredienti',
    ar: 'المكونات',
  },
  allergens: {
    de: 'Allergene',
    en: 'Allergens',
    fr: 'Allergènes',
    es: 'Alérgenos',
    it: 'Allergeni',
    ar: 'مسببات الحساسية',
  },
  contains: {
    de: 'Enthält',
    en: 'Contains',
    fr: 'Contient',
    es: 'Contiene',
    it: 'Contiene',
    ar: 'يحتوي على',
  },
  mayContain: {
    de: 'Kann enthalten',
    en: 'May contain',
    fr: 'Peut contenir',
    es: 'Puede contener',
    it: 'Può contenere',
    ar: 'قد يحتوي على',
  },
}

const ALLERGEN_TRANSLATIONS: Record<string, Record<Language, string>> = {
  gluten: {
    de: 'Glutenhaltiges Getreide',
    en: 'Gluten-containing cereals',
    fr: 'Céréales contenant du gluten',
    es: 'Cereales con gluten',
    it: 'Cereali contenenti glutine',
    ar: 'حبوب تحتوي على الغلوتين',
  },
  crustaceans: {
    de: 'Krebstiere',
    en: 'Crustaceans',
    fr: 'Crustacés',
    es: 'Crustáceos',
    it: 'Crostacei',
    ar: 'قشريات',
  },
  eggs: {
    de: 'Eier',
    en: 'Eggs',
    fr: 'Œufs',
    es: 'Huevos',
    it: 'Uova',
    ar: 'بيض',
  },
  fish: {
    de: 'Fisch',
    en: 'Fish',
    fr: 'Poisson',
    es: 'Pescado',
    it: 'Pesce',
    ar: 'سمك',
  },
  peanuts: {
    de: 'Erdnüsse',
    en: 'Peanuts',
    fr: 'Arachides',
    es: 'Cacahuetes',
    it: 'Arachidi',
    ar: 'فول سوداني',
  },
  soybeans: {
    de: 'Soja',
    en: 'Soybeans',
    fr: 'Soja',
    es: 'Soja',
    it: 'Soia',
    ar: 'فول الصويا',
  },
  milk: {
    de: 'Milch und Laktose',
    en: 'Milk and lactose',
    fr: 'Lait et lactose',
    es: 'Leche y lactosa',
    it: 'Latte e lattosio',
    ar: 'حليب ولاكتوز',
  },
  nuts: {
    de: 'Schalenfrüchte',
    en: 'Tree nuts',
    fr: 'Fruits à coque',
    es: 'Frutos de cáscara',
    it: 'Frutta a guscio',
    ar: 'مكسرات',
  },
  celery: {
    de: 'Sellerie',
    en: 'Celery',
    fr: 'Céleri',
    es: 'Apio',
    it: 'Sedano',
    ar: 'كرفس',
  },
  mustard: {
    de: 'Senf',
    en: 'Mustard',
    fr: 'Moutarde',
    es: 'Mostaza',
    it: 'Senape',
    ar: 'خردل',
  },
  sesame: {
    de: 'Sesamsamen',
    en: 'Sesame seeds',
    fr: 'Graines de sésame',
    es: 'Semillas de sésamo',
    it: 'Semi di sesamo',
    ar: 'بذور السمسم',
  },
  sulphites: {
    de: 'Schwefeldioxid und Sulfite',
    en: 'Sulphur dioxide and sulphites',
    fr: 'Anhydride sulfureux et sulfites',
    es: 'Dióxido de azufre y sulfitos',
    it: 'Anidride solforosa e solfiti',
    ar: 'ثاني أكسيد الكبريت والكبريتات',
  },
  lupin: {
    de: 'Lupinen',
    en: 'Lupin',
    fr: 'Lupin',
    es: 'Altramuces',
    it: 'Lupini',
    ar: 'ترمس',
  },
  molluscs: {
    de: 'Weichtiere',
    en: 'Molluscs',
    fr: 'Mollusques',
    es: 'Moluscos',
    it: 'Molluschi',
    ar: 'رخويات',
  },
}

export function translateLabel(
  key: keyof typeof LABEL_TRANSLATIONS,
  language: Language,
): string {
  return LABEL_TRANSLATIONS[key][language]
}

export function translateAllergen(
  allergenId: string,
  language: Language,
): string {
  return ALLERGEN_TRANSLATIONS[allergenId]?.[language] || allergenId
}

export function isRTL(language: Language): boolean {
  return language === 'ar'
}
